// The kit's checkbox. Not shadcn's Radix one: that reports through
// `onCheckedChange(checked)`, and the pages read `event.target.checked` from
// a native `onChange`. A real checkbox in the pine keeps every handler as it
// is and gives the browser's own keyboard and form behaviour.
import * as React from "react";
import { cn } from "@/lib/utils";

// forwardRef: React 18 (see button.tsx).
const Checkbox = React.forwardRef<HTMLInputElement, Omit<React.ComponentPropsWithoutRef<"input">, "type">>(
  function Checkbox({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        type="checkbox"
        data-slot="checkbox"
        className={cn(
          "size-4 shrink-0 cursor-pointer accent-primary disabled:cursor-not-allowed disabled:opacity-55",
          className,
        )}
        {...props}
      />
    );
  },
);

export { Checkbox };
